import een from "@assets/een.png";
import twee from "@assets/twee.png";
import CustomImage from "@components/custom-image";
import { Text, View } from "dripsy";
import * as React from "react";

export function QualityMarkEko() {
  return <QualityMark image={een} title="W0006" />;
}

export function QualityGreenStars() {
  return <QualityMark image={twee} title="104209" />;
}
function QualityMark({ title, image }: { title: string; image: any }) {
  return (
    <View>
      <CustomImage source={image} sx={{ width: 56, height: 56 }} contentFit="contain" alt={title} />
      <Text
        style={{
          marginTop: 12,
          fontSize: 13,
          opacity: 0.6,
          fontWeight: "bold",
        }}
      >
        {title}
      </Text>
    </View>
  );
}
